import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { GroupService } from '../../services';
import { editedGroupAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_GROUP),
    switchMap(action =>
      GroupService.edit(action.group, store).pipe(
        map(data => editedGroupAction(data)),
        catchError(retryAuthentication(action$, 'epics/groups/editGroup'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/groups/editGroup.js